import contactform from './contactform/contactform';

const reducers = {
  contactform,
};

export default reducers;
